{
  "scripts": {
    "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js": "sha384-VM96ZnWRJL1Ez7nVX13O5k0nAYPXEL56O5CZJgzmzo+UkXbnyQljUv07JTX9HiEf",
    "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js": "sha384-cMI3kSMJ5+nCuUnZfUH0w9jT31i6sBmtVFw782L1hKybyLxynRJiIFtS8MWxpnNy"
  }
}